// MT home dashboard (zone layout) strings: shell (zones, widget chrome,
// reporting period). Keys use the "mtd-" prefix.
export default {
  en: {
    'mtd-zone-other': 'Other',
    'mtd-area-main': 'Main dashboard',
    'mtd-area-panel': 'Quick access panel',
    'mtd-zone-hint':
      'Where this section shows on the home page. Order is kept within each area.',
    'mtd-performance': 'Performance',
    'mtd-operations': 'Operations',
    'mtd-quick-access': 'Quick access',
    'mtd-quick-table': 'Quick table',
    'mtd-full-report': 'Open full report',
    'mtd-reporting-period': 'Reporting period',
    'mtd-more': 'More',
  },
  es: {
    'mtd-zone-other': 'Otros',
    'mtd-area-main': 'Panel principal',
    'mtd-area-panel': 'Panel de acceso rápido',
    'mtd-zone-hint':
      'Dónde aparece esta sección en la página de inicio. El orden se mantiene dentro de cada área.',
    'mtd-performance': 'Desempeño',
    'mtd-operations': 'Operaciones',
    'mtd-quick-access': 'Acceso rápido',
    'mtd-quick-table': 'Tabla rápida',
    'mtd-full-report': 'Abrir informe completo',
    'mtd-reporting-period': 'Período del informe',
    'mtd-more': 'Más',
  },
  fr: {
    'mtd-zone-other': 'Autres',
    'mtd-area-main': 'Tableau de bord principal',
    'mtd-area-panel': 'Panneau d’accès rapide',
    'mtd-zone-hint':
      'Où cette section s’affiche sur la page d’accueil. L’ordre est conservé dans chaque zone.',
    'mtd-performance': 'Performance',
    'mtd-operations': 'Opérations',
    'mtd-quick-access': 'Accès rapide',
    'mtd-quick-table': 'Tableau rapide',
    'mtd-full-report': 'Ouvrir le rapport complet',
    'mtd-reporting-period': 'Période de rapport',
    'mtd-more': 'Plus',
  },
  'fr-ca': {
    'mtd-zone-other': 'Autres',
    'mtd-area-main': 'Tableau de bord principal',
    'mtd-area-panel': 'Panneau d’accès rapide',
    'mtd-zone-hint':
      'Où cette section s’affiche sur la page d’accueil. L’ordre est conservé dans chaque zone.',
    'mtd-performance': 'Performance',
    'mtd-operations': 'Opérations',
    'mtd-quick-access': 'Accès rapide',
    'mtd-quick-table': 'Tableau rapide',
    'mtd-full-report': 'Ouvrir le rapport complet',
    'mtd-reporting-period': 'Période de rapport',
    'mtd-more': 'Plus',
  },
};
